import type { OsmGeoJsonFeature } from './APITypes';

export const osmWayToFeature = (osmWay: any): OsmGeoJsonFeature => {
  const { geojson, ...rest } = osmWay;

  return {
    type: 'Feature',
    id: osmWay.wayId,
    properties: {
      ...rest,
    },
    geometry: {
      type: 'LineString',
      coordinates: geojson.coordinates,
    },
  };
};
